export const changeform = () => {
  /**
   * js-hide-form を非表示にする
   */
  document.head.innerHTML += `<style>
      .js-hide-form {
        display: none !important;
      }
    </style>`;

  /**
   * 勤務先切り替え
   */
  const workingForm = document.querySelectorAll( 'input[data-switch-working]' ) || false;
  const workingItem = document.querySelectorAll( '.js-working' ) || false;
  const otherItem = document.querySelectorAll( '.js-other' ) || false;
  workingForm.forEach( ( workingFormItem ) => {
    workingFormItem.addEventListener( 'change', function () {
      if ( workingFormItem.getAttribute( 'data-switch-working' ) === 'AdressWorking' ) {
        workingItem.forEach( workingItem => {
          // 設問を表示
          workingItem.classList.remove( 'js-hide-form' );
          // バリデーションを有効化
          workingItem.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
        otherItem.forEach( otherItem => {
          // 設問を非表示
          otherItem.classList.add( 'js-hide-form' );
          // バリデーションを無効化
          otherItem.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
      } else if ( workingFormItem.getAttribute( 'data-switch-working' ) === 'Other' ) {
        workingItem.forEach( workingItem => {
          // 設問を非表示
          workingItem.classList.add( 'js-hide-form' );
          // バリデーションを有効化
          workingItem.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
        otherItem.forEach( otherItem => {
          // 設問を表示
          otherItem.classList.remove( 'js-hide-form' );
          // バリデーションを有効化
          otherItem.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( workingFormItem.getAttribute( 'data-switch-working' ) === 'None' ) {
        workingItem.forEach( workingItem => {
          // 設問を非表示
          workingItem.classList.add( 'js-hide-form' );
          // バリデーションを無効化
          workingItem.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
        otherItem.forEach( otherItem => {
          // 設問を非表示
          otherItem.classList.add( 'js-hide-form' );
          // バリデーションを無効化
          otherItem.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
      }
    } );
  } );

  /**
   * 工事場所切り替え
   */
  // const constructionForm = document.querySelectorAll( 'input[data-switch-construction]' ) || false;
  // const constructionItems = document.querySelectorAll( '.js-construction' ) || false;
  // constructionForm.forEach( ( constructionFormItem ) => {
  //   constructionFormItem.addEventListener( 'change', () => {
  //     if ( constructionFormItem.getAttribute( 'data-switch-construction' ) === 'Construction' ) {
  //       constructionItems.forEach( constructionItem => {
  //         constructionItem.classList.remove( 'js-hide-form' );
  //         constructionItem.style.display = 'block';
  //       } );
  //     } else if ( constructionFormItem.getAttribute( 'data-switch-construction' ) === 'None' ) {
  //       constructionItems.forEach( constructionItem => {
  //         constructionItem.classList.add( 'js-hide-form' );
  //         constructionItem.style.display = 'none';
  //       } );
  //     }
  //   } );
  // } );

  /**
   * 学籍番号　・　受験番号切り替え
   */
  const numberForm = document.querySelectorAll( 'input[data-switch-number]' ) || false;
  const numberInput = document.querySelector( '.js-number' ) || false;
  numberForm.forEach( numberFormItem => {
    numberFormItem.addEventListener( 'change', () => {
      // 設問を表示
      numberInput.classList.remove( 'js-hide-form' );

      if ( numberFormItem.getAttribute( 'data-switch-number' ) === 'StudentNum' ) {
        // バリデーションを有効化
        numberInput.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
          target.classList.remove( 'is--invalidValidation' );
        } );
      } else if ( numberFormItem.getAttribute( 'data-switch-number' ) === 'None' ) {
        // バリデーションを無効化
        numberInput.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
          target.classList.add( 'is--invalidValidation' );
        } );
      }
    } );
  } );

  /**
   * セレクトボタンでの設問の切り替え
   */
  const selectsForm = document.querySelectorAll( 'select[data-switch-form]' ) || false;

  const formSelect               = document.querySelectorAll( '.js-formSelect' ) || false;

  const formSelectPension        = document.querySelectorAll( '.js-formSelectPension' ) || false;
  const formSelectStudent        = document.querySelectorAll( '.js-formSelectStudent' ) || false;
  const formSelectWorking        = document.querySelectorAll( '.js-formSelectWorking' ) || false;
  const formSelectStudentPension = document.querySelectorAll( '.js-formSelectStudentPension' ) || false;
  const formSelectOthers         = document.querySelectorAll( '.js-formSelectOthers' ) || false;

  selectsForm.forEach( selectsFormItem => {
    selectsFormItem.addEventListener( 'change', ( e ) => {
      formSelect.forEach( item => {
        item.classList.add( 'js-hide-form' );
        item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
          target.classList.add( 'is--invalidValidation' );
        } );
      } );

      const option = e.target.querySelectorAll( 'option' )[ e.target.selectedIndex ];
      const attr   = option.getAttribute( 'data-switch-form-item' );

      if ( attr === 'Pension' ) {
        formSelectPension.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( attr === 'Student' ) {
        formSelectStudent.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( attr === 'Working' ) {
        formSelectWorking.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( attr === 'StudentPension' ) {
        formSelectStudentPension.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( attr === 'Others' ) {
        formSelectOthers.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      }
    } );
  } );

  /**
   * 個人　・　法人切り替え
   */
  const mediumForm = document.querySelectorAll( 'input[data-switch-medium]' ) || false;

  const individual = document.querySelectorAll( '.js-individual' );
  const company = document.querySelectorAll( '.js-company' );

  mediumForm.forEach( mediumFormItem => {
    if ( mediumFormItem.checked && mediumFormItem.getAttribute( 'data-switch-medium' ) === 'Individual' ) {
      individual.forEach( item => {
        item.classList.remove( 'js-hide-form' );
        item.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
          target.classList.remove( 'is--invalidValidation' );
        } );
      } );
    } else if ( mediumFormItem.checked && mediumFormItem.getAttribute( 'data-switch-medium' ) === 'Company' ) {
      company.forEach( item => {
        item.classList.remove( 'js-hide-form' );
        item.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
          target.classList.remove( 'is--invalidValidation' );
        } );
      } );
    }

    mediumFormItem.addEventListener( 'change', () => {
      if ( mediumFormItem.getAttribute( 'data-switch-medium' ) === 'Individual' ) {
        individual.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
        company.forEach( item => {
          item.classList.add( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
      } else if ( mediumFormItem.getAttribute( 'data-switch-medium' ) === 'Company' ) {
        individual.forEach( item => {
          item.classList.add( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
        company.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      }
    } );
  } );

  /**
   * ボーナス併用 有無切り替え
   */
  const bonusForm = document.querySelectorAll( 'input[data-switch-bonus]' ) || false;

  const bonusItem = document.querySelectorAll( '.js-bonus' ) || false;

  bonusForm.forEach( bonusFormItem => {
    bonusFormItem.addEventListener( 'change', () => {
      if ( bonusFormItem.getAttribute( 'data-switch-bonus' ) === 'Bonus' ) {
        bonusItem.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( bonusFormItem.getAttribute( 'data-switch-bonus' ) === 'None' ) {
        bonusItem.forEach( item => {
          item.classList.add( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
      }
    } );
  } );

  /**
   * 希望日時 の切り替え
   */
  const dateForm = document.querySelectorAll( 'input[data-switch-date]' ) || false;
  const timeForm = document.querySelectorAll( 'input[data-switch-time]' ) || false;

  const date = document.querySelector( '.js-date' ) || false;
  const timeZone = document.querySelector( '.js-timeZone' ) || false;
  const time = document.querySelector( '.js-time' ) || false;

  dateForm.forEach( dateFormItem => {
    dateFormItem.addEventListener( 'change', () => {
      if ( dateFormItem.getAttribute( 'data-switch-date' ) === 'Date' ) {
        date.classList.remove( 'js-hide-form' );
        date.querySelector( '.c-select' ).classList.remove( 'is--invalidValidation' );        
      } else if ( dateFormItem.getAttribute( 'data-switch-date' ) === 'None' ) {
        date.classList.add( 'js-hide-form' );
        date.querySelector( '.c-select' ).classList.add( 'is--invalidValidation' );
      }
    } );
  } );

  timeForm.forEach( timeFormItem => {
    timeFormItem.addEventListener( 'change', () => {

      if ( timeFormItem.getAttribute( 'data-switch-time' ) === 'Time' ) {
        time.classList.remove( 'js-hide-form' );
        time.querySelector( '.c-select' ).classList.remove( 'is--invalidValidation' );
        timeZone.classList.add( 'js-hide-form' );
        timeZone.querySelector( '.c-select' ).classList.add( 'is--invalidValidation' );
      } else if ( timeFormItem.getAttribute( 'data-switch-time' ) === 'TimeZone' ) {
        time.classList.add( 'js-hide-form' );
        time.querySelector( '.c-select' ).classList.add( 'is--invalidValidation' );
        timeZone.classList.remove( 'js-hide-form' );
        timeZone.querySelector( '.c-select' ).classList.remove( 'is--invalidValidation' );
      } else if ( timeFormItem.getAttribute( 'data-switch-time' ) === 'None' ) {
        time.classList.add( 'js-hide-form' );
        time.querySelector( '.c-select' ).classList.add( 'is--invalidValidation' );
        timeZone.classList.add( 'js-hide-form' );
        timeZone.querySelector( '.c-select' ).classList.add( 'is--invalidValidation' );
      }
    } );
  } );
  
  /**
   * シュミレーション方法切り替え
   */
  const simulationForm = document.querySelectorAll( 'input[data-switch-simulation]' ) || false;
  const simulationBunkatsu = document.querySelector( '.js-simulation-bunkatsu' ) || false;
  const simulationPrice = document.querySelector( '.js-simulation-price' ) || false;

  simulationForm.forEach( simulationFormItem => {
    simulationFormItem.addEventListener( 'change', () => {
      if ( simulationFormItem.getAttribute( 'data-switch-simulation' ) === 'Bunkatsu' ) {
        simulationBunkatsu.classList.remove( 'js-hide-form' );
        simulationBunkatsu.querySelector( '.c-select' ).classList.remove( 'is--invalidValidation' );
        simulationPrice.classList.add( 'js-hide-form' );
        simulationPrice.querySelector( '.c-input' ).classList.add( 'is--invalidValidation' );
      } else if ( simulationFormItem.getAttribute( 'data-switch-simulation' ) === 'Price' ) {
        simulationBunkatsu.classList.add( 'js-hide-form' );
        simulationBunkatsu.querySelector( '.c-select' ).classList.add( 'is--invalidValidation' );
        simulationPrice.classList.remove( 'js-hide-form' );
        simulationPrice.querySelector( '.c-input' ).classList.remove( 'is--invalidValidation' );
      }
    } );
  } );

  /**
   * 据置支払い切り替え
   */
  const paymentForm = document.querySelectorAll( 'input[data-switch-payment]' ) || false;

  const paymentItem = document.querySelectorAll( '.js-payment' ) || false;

  paymentForm.forEach( paymentFormItem => {
    paymentFormItem.addEventListener( 'change', () => {
      if ( paymentFormItem.getAttribute( 'data-switch-payment' ) === 'Payment' ) {
        paymentItem.forEach( item => {
          item.classList.remove( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.remove( 'is--invalidValidation' );
          } );
        } );
      } else if ( paymentFormItem.getAttribute( 'data-switch-payment' ) === 'None' ) {
        paymentItem.forEach( item => {
          item.classList.add( 'js-hide-form' );
          item.querySelectorAll( '.c-input,.c-textarea,.c-select' ).forEach( target => {
            target.classList.add( 'is--invalidValidation' );
          } );
        } );
      }
    } );
  } );

  /**
   * 据置支払い切り替え（２）
   */
  const paymentForm2 = document.querySelectorAll( 'input[data-switch-payment2]' ) || false;

  const paymentItemNo = document.querySelector( '.js-payment-no' ) || false;
  const paymentItemYes = document.querySelector( '.js-payment-yes' ) || false;

  paymentForm2.forEach( paymentFormItem => {
    paymentFormItem.addEventListener( 'change', () => {
      if ( paymentFormItem.getAttribute( 'data-switch-payment2' ) === 'No' ) {
        paymentItemNo.classList.remove( 'js-hide-form' );
        paymentItemNo.classList.remove( 'is--invalidValidation' );
        paymentItemYes.classList.add( 'js-hide-form' );
        paymentItemYes.classList.add( 'is--invalidValidation' );
      } else if ( paymentFormItem.getAttribute( 'data-switch-payment2' ) === 'Yes' ) {
        paymentItemNo.classList.add( 'js-hide-form' );
        paymentItemNo.classList.add( 'is--invalidValidation' );
        paymentItemYes.classList.remove( 'js-hide-form' );
        paymentItemYes.classList.remove( 'is--invalidValidation' );
      }
    } );
  } );

  /**
   * 本人・本人以外切り替え
   */
  const personForm1 = document.querySelectorAll( 'input[data-switch-honnninn1]' ) || false;
  const personItem1 = document.querySelector( '.js-honnninn1' ) || false;

  personForm1.forEach( personFormItem => {
    personFormItem.addEventListener( 'change', () => {
      if ( personFormItem.getAttribute( 'data-switch-honnninn1' ) === 'No' ) {
        personItem1.classList.remove( 'js-hide-form' );
        personItem1.querySelector( '.c-input' ).classList.remove( 'is--invalidValidation' );
      } else if ( personFormItem.getAttribute( 'data-switch-honnninn1' ) === 'Yes' ) {
        personItem1.classList.add( 'js-hide-form' );
        personItem1.querySelector( '.c-input' ).classList.add( 'is--invalidValidation' );
      }
    } );
  } );

  const personForm2 = document.querySelectorAll( 'input[data-switch-honnninn2]' ) || false;
  const personItem2 = document.querySelector( '.js-honnninn2' ) || false;

  personForm2.forEach( personFormItem => {
    personFormItem.addEventListener( 'change', () => {
      if ( personFormItem.getAttribute( 'data-switch-honnninn2' ) === 'No' ) {
        personItem2.classList.remove( 'js-hide-form' );
        personItem2.querySelector( '.c-input' ).classList.remove( 'is--invalidValidation' );
      } else if ( personFormItem.getAttribute( 'data-switch-honnninn2' ) === 'Yes' ) {
        personItem2.classList.add( 'js-hide-form' );
        personItem2.querySelector( '.c-input' ).classList.add( 'is--invalidValidation' );
      }
    } );
  } );
}
